// extracted by mini-css-extract-plugin
export var border = "_t-7";
export var brand = "_t-s";
export var button = "_t-k";
export var center = "_t-9";
export var centered = "_t-5";
export var closeButton = "_t-b";
export var disabledWrapper = "_t-l";
export var error = "_t-o";
export var extraLarge = "_t-4";
export var extraSmall = "_t-1";
export var fill = "_t-h";
export var footer = "_t-g";
export var footerAction = "_t-i";
export var footerButtons = "_t-j";
export var header = "_t-6";
export var headerWithClose = "_t-c";
export var icon = "_t-n";
export var info = "_t-r";
export var inline = "_t-8";
export var large = "_t-3";
export var main = "_t-d";
export var modal = "_t-0";
export var neutral = "_t-t";
export var noPadding = "_t-f";
export var none = "_t-u";
export var scrollable = "_t-e";
export var small = "_t-2";
export var success = "_t-q";
export var tight = "_t-m";
export var titleIcon = "_t-a";
export var warn = "_t-p";